import PropTypes from 'prop-types';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';

export const ParentCustomerNodeShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  name: PropTypes.string,
  href: PropTypes.string,
});

export const BreadCrumbItemShape = PropTypes.shape({
  key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  text: PropTypes.string.isRequired,
  href: PropTypes.string,
});

export const AccountSelectorPropTypes = {
  /**
   * Client Center Customer Service to Fetch Customer Hierarchy Entities
  */
  ccCustomerService: PropTypes.shape({
    getRecentAccesssEntities: PropTypes.func.isRequired,
    getCustomerHierarchy: PropTypes.func.isRequired,
    getAncestorHierarchyPath: PropTypes.func.isRequired,
    getUserPreferences: PropTypes.func.isRequired,
    setUserPreferences: PropTypes.func.isRequired,
  }).isRequired,
  /**
   * function to render a node given an entity object, default renders a span with hyperlink
  */
  nodeRenderer: PropTypes.func,
  /**
   * function to return the target url for an entity
  */
  updateEntityUrl: PropTypes.func,
  /**
   * root customer id or the login user's parent customer id
  */
  rootCustomerId: PropTypes.number.isRequired,
  /**
   * each node height, will be used to calculate the height when autoHeight is enabled.
   */
  cellHeight: PropTypes.number,
  /**
   * user id of the current user context
  */
  userId: PropTypes.number.isRequired,
  /**
   * toggle showAccountSelectorView
  */
  showAccountSelectorView: PropTypes.bool,
  /**
   * switchAccountsLabelClicked
  */
  switchAccountsLabelClicked: PropTypes.func,
  /**
   * indication if parent component handles view toggle logic on its own
  */
  overrideToggleEvent: PropTypes.bool,
  /**
   * selected account/ customer entity id
  */
  selectedEntity: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    isCustomer: PropTypes.bool.isRequired,
  }).isRequired,
  /**
   * i18n localization object
  */
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  /**
   * ignores filtering accounts
  */
  ignoreFilter: PropTypes.bool,
  /**
   * customized toggle component for filtering inactive accounts
  */
  inactiveAccountFilter: PropTypes.bool,
  /**
   * used to request nodes of size batchSize when onscrollload is enabled. can be null
  */
  batchSize: PropTypes.number,
  /**
   * automatically adjust height of the tree view based on nodes
  */
  autoHeight: PropTypes.bool,
  /**
   * load tree view level wise if this is true
  */
  returnOnlyDirectlyLinkedEntities: PropTypes.bool,
  /**
   * enable this to load paginated data
  */
  enableOnScrollLoad: PropTypes.bool,
  /**
   * Customized renderer to render a breadcrumb item
   */
  breadcrumbItemRenderer: PropTypes.func,
  /**
   * Performance logging marker to capture latency from clicking account dropdown header option
   */
  perfMarker: perfMarkerPropTypes,
};

export const AccountSelectorWithUrlChangePropTypes = {
  ...AccountSelectorPropTypes,
  /**
   * route location of the current page
  */
  routeLocation: PropTypes.string.isRequired,
};

export const AccountSelectorWithHeaderPropTypes = {
  ...AccountSelectorPropTypes,
  /**
   * title displayed on the header
  */
  title: PropTypes.string.isRequired,
  /**
   * subtitle displayed on the header
  */
  subTitle: PropTypes.string.isRequired,
};

export const DummyAccountSelectorPropTypes = {
  ...AccountSelectorPropTypes,

  // Make below props optional for dummy to avoid console warnings
  ccCustomerService: PropTypes.shape({}),
  selectedEntity: PropTypes.shape({}),
  i18n: PropTypes.shape({}),
  rootCustomerId: PropTypes.number,
  userId: PropTypes.number,
};
